import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DropdownManagerService {
  private activeDropdownId: string | null = null;
  private closeAllDropdowns$ = new Subject<void>();

  closeAllDropdowns = this.closeAllDropdowns$.asObservable();

  registerDropdown(id: string): void {
    if (this.activeDropdownId && this.activeDropdownId !== id) {
      this.closeAllDropdowns$.next();
    }
    this.activeDropdownId = id;
  }

  unregisterDropdown(id: string): void {
    if (this.activeDropdownId === id) {
      this.activeDropdownId = null;
    }
  }

  closeAll(): void {
    this.closeAllDropdowns$.next();
    this.activeDropdownId = null;
  }
}